export { PlaceholderIcon as IngredientsFibersIcon } from "./placeholder";
